<template>
  <cms-call-to-action
    v-if="callToActionSetUp"
    :theme="callToActionOptions"
    :content="getHomepage.call_to_action[id]"
  />
</template>
<script>
import { mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'ViewCallToAction',
  props: {
    containerIdx: {
      type: Number,
      default: null,
    },
    containerId: {
      type: String,
      default: null,
    },
    componentIdx: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapGetters(['getTheme', 'getHomepage', 'isThemePreview', 'getGlobalThemeSettings']),
    ...mapGetters('translation', ['getComponentTranslation']),
    id() {
      if (this.isThemePreview) return 'preview_id';
      return `${this.containerId}_${this.componentIdx}`;
    },
    callToActionOptions() {
      const themeOptions =
        this.getTheme?.containers?.[this.containerIdx]?.components?.[this.componentIdx]?.options ?? {};
      return {
        ...themeOptions,
        globalThemeSettings: this.getGlobalThemeSettings ?? {},
      };
    },
    callToActionSetUp() {
      const cta = this.getHomepage?.call_to_action?.[this.id];
      return !!cta && !isEmpty(cta);
    },
  },
};
</script>
